<!-- Microsoft Office Professional Navigation Sidebar Starts -->
<div id="sidebar" class="ms-office-sidebar">
  
  <!-- Sidebar Header Banner -->
  <div class="ms-sidebar-header d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
      <div class="ms-brand-badge me-2">
        <i class="fas fa-th"></i>
      </div>
      <div>
        <h5 class="ms-sidebar-title mb-0">Navigation</h5>
        <small class="ms-sidebar-subtitle" *ngIf="DispalyName">{{DispalyName}} ({{RoleName || 'User'}})</small>
      </div>
    </div>
    
    <div class="ms-sidebar-actions d-flex align-items-center">
      <button type="button" class="btn btn-icon ms-action-btn me-1" (click)="expandAll()" title="Expand All Sections">
        <i class="fas fa-layer-group"></i>
      </button>
      <button type="button" class="btn btn-icon ms-action-btn me-1" (click)="collapseAll()" title="Collapse All Sections">
        <i class="fas fa-compress-alt"></i>
      </button>
      <button type="button" class="btn btn-icon ms-close-btn" (click)="onCloseClick()" aria-label="Close Navigation">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>

  <!-- Sidebar Accordion Scroll Body -->
  <div class="ms-sidebar-content">
    <div class="ms-accordion-list">

      <!-- 1. Registration -->
      <div class="ms-sidebar-section" [class.is-open]="isSectionOpen('registration')">
        <div class="ms-section-header" (click)="toggleSection('registration')">
          <div class="d-flex align-items-center">
            <div class="ms-section-icon-wrapper ms-icon-blue">
              <i class="fas fa-id-card-alt"></i>
            </div>
            <span class="ms-section-label">Registration</span>
          </div>
          <i class="fas fa-chevron-right ms-chevron-icon" [class.rotated]="isSectionOpen('registration')"></i>
        </div>
        <div class="ms-section-body" [class.show]="isSectionOpen('registration')">
          <ul class="ms-menu-links">
            <li *canUserAccess="['HL_REG_1']">
              <a class="ms-nav-link" (click)="OpenModal()">
                <i class="fas fa-plus-circle ms-item-icon text-primary"></i>
                <span>New Patient</span>
              </a>
            </li>
            <li *canUserAccess="['HL_REG_10']">
              <a class="ms-nav-link" (click)="OpenEnquiry()">
                <i class="fas fa-question-circle ms-item-icon text-info"></i>
                <span>Enquiry</span>
              </a>
            </li>
            <li *canUserAccess="['HL_REG_2']">
              <a class="ms-nav-link" [routerLink]="['/healins/dashboard']" (click)="Event()">
                <i class="fas fa-users ms-item-icon text-secondary"></i>
                <span>Patients List</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 2. Follow Up -->
      <div class="ms-sidebar-section" [class.is-open]="isSectionOpen('followUp')">
        <div class="ms-section-header" (click)="toggleSection('followUp')">
          <div class="d-flex align-items-center">
            <div class="ms-section-icon-wrapper ms-icon-purple">
              <i class="fas fa-user-clock"></i>
            </div>
            <span class="ms-section-label">Follow Up</span>
          </div>
          <i class="fas fa-chevron-right ms-chevron-icon" [class.rotated]="isSectionOpen('followUp')"></i>
        </div>
        <div class="ms-section-body" [class.show]="isSectionOpen('followUp')">
          <ul class="ms-menu-links">
            <li *canUserAccess="['HL_FU_1']">
              <a class="ms-nav-link" [routerLink]="['/healins/counsellingregister']" (click)="Event()">
                <i class="fas fa-clipboard-list ms-item-icon"></i>
                <span>Counselling Register</span>
              </a>
            </li>
            <li *canUserAccess="['HL_FU_2']">
              <a class="ms-nav-link" [routerLink]="['/healins/dailyworkbook']" (click)="Event()">
                <i class="fas fa-book-open ms-item-icon"></i>
                <span>Daily Work Book</span>
              </a>
            </li>
            <li *canUserAccess="['HL_FU_3']">
              <a class="ms-nav-link" [routerLink]="['/healins/myworkbook']" (click)="Event()">
                <i class="fas fa-bookmark ms-item-icon"></i>
                <span>My Work Book</span>
              </a>
            </li>
            <li>
              <a class="ms-nav-link is-disabled">
                <i class="fas fa-lock ms-item-icon"></i>
                <span>Reports</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 3. Appointments -->
      <div class="ms-sidebar-section" [class.is-open]="isSectionOpen('appointments')">
        <div class="ms-section-header" (click)="toggleSection('appointments')">
          <div class="d-flex align-items-center">
            <div class="ms-section-icon-wrapper ms-icon-teal">
              <i class="far fa-calendar-check"></i>
            </div>
            <span class="ms-section-label">Appointments</span>
          </div>
          <i class="fas fa-chevron-right ms-chevron-icon" [class.rotated]="isSectionOpen('appointments')"></i>
        </div>
        <div class="ms-section-body" [class.show]="isSectionOpen('appointments')">
          <ul class="ms-menu-links">
            <li *canUserAccess="['HL_BL_HIDE']">
              <a class="ms-nav-link" [routerLink]="['/healins/fdappoinment']" (click)="Event()">
                <i class="fas fa-calendar-plus ms-item-icon text-success"></i>
                <span>Book Appointments</span>
              </a>
            </li>
            <li *canUserAccess="['HL_SCH_1']">
              <a class="ms-nav-link" [routerLink]="['/healins/fdappoinmentadv']" (click)="Event()">
                <i class="fas fa-calendar-alt ms-item-icon text-primary"></i>
                <span>All Branches Appointments</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BL_HIDE']">
              <a class="ms-nav-link is-disabled">
                <i class="fas fa-calendar-times ms-item-icon"></i>
                <span>Cancel Appointments</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BL_HIDE']">
              <a class="ms-nav-link" [routerLink]="['/healins/visitreg']" (click)="Event()">
                <i class="fas fa-clipboard-check ms-item-icon text-info"></i>
                <span>Visit Register</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 4. Billing(Pharmacy) -->
      <div class="ms-sidebar-section" *canUserAccess="['HL_BL_HIDE']" [class.is-open]="isSectionOpen('billingPharmacy')">
        <div class="ms-section-header" (click)="toggleSection('billingPharmacy')">
          <div class="d-flex align-items-center">
            <div class="ms-section-icon-wrapper ms-icon-amber">
              <i class="fas fa-pills"></i>
            </div>
            <span class="ms-section-label">Billing (Pharmacy)</span>
          </div>
          <i class="fas fa-chevron-right ms-chevron-icon" [class.rotated]="isSectionOpen('billingPharmacy')"></i>
        </div>
        <div class="ms-section-body" [class.show]="isSectionOpen('billingPharmacy')">
          <ul class="ms-menu-links">
            <li><a class="ms-nav-link is-disabled"><i class="fas fa-lock ms-item-icon"></i><span>New Bill</span></a></li>
            <li><a class="ms-nav-link is-disabled"><i class="fas fa-lock ms-item-icon"></i><span>View Bills</span></a></li>
            <li><a class="ms-nav-link is-disabled"><i class="fas fa-lock ms-item-icon"></i><span>Refund</span></a></li>
          </ul>
        </div>
      </div>

      <!-- 5. Billing -->
      <div class="ms-sidebar-section" [class.is-open]="isSectionOpen('billing')">
        <div class="ms-section-header" (click)="toggleSection('billing')">
          <div class="d-flex align-items-center">
            <div class="ms-section-icon-wrapper ms-icon-green">
              <i class="fas fa-receipt"></i>
            </div>
            <span class="ms-section-label">Billing</span>
          </div>
          <i class="fas fa-chevron-right ms-chevron-icon" [class.rotated]="isSectionOpen('billing')"></i>
        </div>
        <div class="ms-section-body" [class.show]="isSectionOpen('billing')">
          <ul class="ms-menu-links">
            <li *canUserAccess="['HL_BL_5']" hidden>
              <a class="ms-nav-link" (click)="OpenBillAdv()">
                <i class="fas fa-plus-circle ms-item-icon text-success"></i>
                <span>New Op Adv</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BL_1']">
              <a class="ms-nav-link" [routerLink]="['/healins/opbilling']" (click)="Event()">
                <i class="fas fa-file-invoice-dollar ms-item-icon text-success"></i>
                <span>View Bills</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BL_ViewPPBills']">
              <a class="ms-nav-link" [routerLink]="['/healins/opbillingpp']" (click)="Event()">
                <i class="fas fa-file-invoice ms-item-icon text-primary"></i>
                <span>View PP Bills</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BL_ViewNPBills']">
              <a class="ms-nav-link" [routerLink]="['/healins/opbillingnp']" (click)="Event()">
                <i class="fas fa-file-invoice ms-item-icon text-info"></i>
                <span>View NP Bills</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BL_2']">
              <a class="ms-nav-link" [routerLink]="['/healins/pharmacybill']" (click)="Event()">
                <i class="fas fa-prescription-bottle-alt ms-item-icon text-warning"></i>
                <span>View Pharmacy Bills</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BL_28']">
              <a class="ms-nav-link" [routerLink]="['/healins/combinedbilling']" (click)="Event()">
                <i class="fas fa-calculator ms-item-icon text-purple"></i>
                <span>Bills (OP + RX)</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BL_HIDE']">
              <a class="ms-nav-link" [routerLink]="['/healins/itemcatalogue']" (click)="Event()">
                <i class="fas fa-book ms-item-icon"></i>
                <span>Catalogue</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BL_HIDE']">
              <a class="ms-nav-link" [routerLink]="['/healins/customerorders']" (click)="Event()">
                <i class="fas fa-shopping-cart ms-item-icon"></i>
                <span>Customer Orders</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BL_7']">
              <a class="ms-nav-link" [routerLink]="['/healins/refundslist']" (click)="Event()">
                <i class="fas fa-undo-alt ms-item-icon text-danger"></i>
                <span>Refunds</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BL_HIDE']">
              <a class="ms-nav-link is-disabled">
                <i class="fas fa-lock ms-item-icon"></i>
                <span>Advances</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 6. Bill Verifications -->
      <div class="ms-sidebar-section" [class.is-open]="isSectionOpen('billVerifications')">
        <div class="ms-section-header" (click)="toggleSection('billVerifications')">
          <div class="d-flex align-items-center">
            <div class="ms-section-icon-wrapper ms-icon-indigo">
              <i class="fas fa-file-contract"></i>
            </div>
            <span class="ms-section-label">Bill Verifications</span>
          </div>
          <i class="fas fa-chevron-right ms-chevron-icon" [class.rotated]="isSectionOpen('billVerifications')"></i>
        </div>
        <div class="ms-section-body" [class.show]="isSectionOpen('billVerifications')">
          <ul class="ms-menu-links">
            <li *canUserAccess="['HL_BV_1']">
              <a class="ms-nav-link" [routerLink]="['/healins/billverfication']" (click)="Event()">
                <i class="fas fa-check-double ms-item-icon text-indigo"></i>
                <span>OP Bill Verifications</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BV_3']">
              <a class="ms-nav-link" [routerLink]="['/healins/opbillservicestra']" (click)="Event()">
                <i class="fas fa-route ms-item-icon text-info"></i>
                <span>OP Bill Service Tracking</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BV_2']">
              <a class="ms-nav-link" [routerLink]="['/healins/ipbillverfication']" (click)="Event()">
                <i class="fas fa-check-circle ms-item-icon text-indigo"></i>
                <span>IP Bill Verifications</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BV_4']">
              <a class="ms-nav-link" [routerLink]="['/healins/ipbillservicestra']" (click)="Event()">
                <i class="fas fa-tasks ms-item-icon text-primary"></i>
                <span>IP Bill Service Tracking</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BV_5']">
              <a class="ms-nav-link" [routerLink]="['/healins/strackingreport']" (click)="Event()">
                <i class="fas fa-chart-line ms-item-icon text-success"></i>
                <span>Service Tracking Report</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 7. Lab -->
      <div class="ms-sidebar-section" [class.is-open]="isSectionOpen('lab')">
        <div class="ms-section-header" (click)="toggleSection('lab')">
          <div class="d-flex align-items-center">
            <div class="ms-section-icon-wrapper ms-icon-purple">
              <i class="fas fa-vials"></i>
            </div>
            <span class="ms-section-label">Lab</span>
          </div>
          <i class="fas fa-chevron-right ms-chevron-icon" [class.rotated]="isSectionOpen('lab')"></i>
        </div>
        <div class="ms-section-body" [class.show]="isSectionOpen('lab')">
          <ul class="ms-menu-links">
            <li *canUserAccess="['HL_LAB_1']">
              <a class="ms-nav-link" [routerLink]="['/healins/labdas']" (click)="Event()">
                <i class="fas fa-microscope ms-item-icon text-purple"></i>
                <span>Lab Orders</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BL_HIDE']">
              <a class="ms-nav-link is-disabled"><i class="fas fa-lock ms-item-icon"></i><span>Order Request</span></a>
            </li>
            <li *canUserAccess="['HL_BL_HIDE']">
              <a class="ms-nav-link" [routerLink]="['/healins/lab']" (click)="Event()">
                <i class="fas fa-flask ms-item-icon text-primary"></i>
                <span>Specimen Collections</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BL_HIDE']">
              <a class="ms-nav-link is-disabled"><i class="fas fa-lock ms-item-icon"></i><span>Results</span></a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 8. In Patient -->
      <div class="ms-sidebar-section" [class.is-open]="isSectionOpen('inPatient')">
        <div class="ms-section-header" (click)="toggleSection('inPatient')">
          <div class="d-flex align-items-center">
            <div class="ms-section-icon-wrapper ms-icon-cyan">
              <i class="fas fa-procedures"></i>
            </div>
            <span class="ms-section-label">In Patient</span>
          </div>
          <i class="fas fa-chevron-right ms-chevron-icon" [class.rotated]="isSectionOpen('inPatient')"></i>
        </div>
        <div class="ms-section-body" [class.show]="isSectionOpen('inPatient')">
          <ul class="ms-menu-links">
            <li *canUserAccess="['HL_AD_1']">
              <a class="ms-nav-link" [routerLink]="['/healins/admissions']" (click)="Event()">
                <i class="fas fa-hospital-user ms-item-icon text-cyan"></i>
                <span>Admissions</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-nav-link is-disabled"><i class="fas fa-lock ms-item-icon"></i><span>Billing</span></a></li>
            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-nav-link is-disabled"><i class="fas fa-lock ms-item-icon"></i><span>Discharges</span></a></li>
            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-nav-link is-disabled"><i class="fas fa-lock ms-item-icon"></i><span>Transfers</span></a></li>
          </ul>
        </div>
      </div>

      <!-- 9. EHR -->
      <div class="ms-sidebar-section" *canUserAccess="['HL_BL_HIDE']" [class.is-open]="isSectionOpen('ehr')">
        <div class="ms-section-header" (click)="toggleSection('ehr')">
          <div class="d-flex align-items-center">
            <div class="ms-section-icon-wrapper ms-icon-coral">
              <i class="fas fa-file-medical-alt"></i>
            </div>
            <span class="ms-section-label">EHR</span>
          </div>
          <i class="fas fa-chevron-right ms-chevron-icon" [class.rotated]="isSectionOpen('ehr')"></i>
        </div>
        <div class="ms-section-body" [class.show]="isSectionOpen('ehr')">
          <ul class="ms-menu-links">
            <li><a class="ms-nav-link is-disabled"><i class="fas fa-plus ms-item-icon"></i><span>Add Record</span></a></li>
          </ul>
        </div>
      </div>

      <!-- 10. IVF @ Home -->
      <div class="ms-sidebar-section" *canUserAccess="['HL_BL_HIDE']" [class.is-open]="isSectionOpen('ivfHome')">
        <div class="ms-section-header" (click)="toggleSection('ivfHome')">
          <div class="d-flex align-items-center">
            <div class="ms-section-icon-wrapper ms-icon-pink">
              <i class="fas fa-heartbeat"></i>
            </div>
            <span class="ms-section-label">IVF &#64; Home</span>
          </div>
          <i class="fas fa-chevron-right ms-chevron-icon" [class.rotated]="isSectionOpen('ivfHome')"></i>
        </div>
        <div class="ms-section-body" [class.show]="isSectionOpen('ivfHome')">
          <ul class="ms-menu-links">
            <li>
              <a class="ms-nav-link" (click)="OpenBill()">
                <i class="fas fa-plus-circle ms-item-icon text-danger"></i>
                <span>New Order</span>
              </a>
            </li>
            <li>
              <a class="ms-nav-link" [routerLink]="['/healins/iohorders']" (click)="Event()">
                <i class="fas fa-boxes ms-item-icon text-primary"></i>
                <span>IVF &#64; Home Orders</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 11. IVF -->
      <div class="ms-sidebar-section" [class.is-open]="isSectionOpen('ivf')">
        <div class="ms-section-header" (click)="toggleSection('ivf')">
          <div class="d-flex align-items-center">
            <div class="ms-section-icon-wrapper ms-icon-blue">
              <i class="fas fa-dna"></i>
            </div>
            <span class="ms-section-label">IVF</span>
          </div>
          <i class="fas fa-chevron-right ms-chevron-icon" [class.rotated]="isSectionOpen('ivf')"></i>
        </div>
        <div class="ms-section-body" [class.show]="isSectionOpen('ivf')">
          <ul class="ms-menu-links">
            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-nav-link is-disabled"><i class="fas fa-plus ms-item-icon"></i><span>New Cycle</span></a></li>
            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-nav-link is-disabled"><i class="fas fa-lock ms-item-icon"></i><span>Donors</span></a></li>
            <li *canUserAccess="['HL_IVF_2']">
              <a class="ms-nav-link" [routerLink]="['/healins/ivfdashboard2']" (click)="Event()">
                <i class="fas fa-sync-alt ms-item-icon text-primary"></i>
                <span>Treatment Cycles</span>
              </a>
            </li>
            <li *canUserAccess="['EggDonorDashboard']">
              <a class="ms-nav-link" [routerLink]="['/healins/eggdonordashboard']" (click)="Event()">
                <i class="fas fa-female ms-item-icon text-pink"></i>
                <span>Egg Donors</span>
              </a>
            </li>
            <li *canUserAccess="['FolScanDashboard']">
              <a class="ms-nav-link" [routerLink]="['/healins/follicularscansdashboard']" (click)="Event()">
                <i class="fas fa-search-plus ms-item-icon text-info"></i>
                <span>Follicular Scans</span>
              </a>
            </li>
            <li *canUserAccess="['HL_IVF_3']">
              <a class="ms-nav-link" [routerLink]="['/healins/ivfworkbench']" (click)="Event()">
                <i class="fas fa-laptop-medical ms-item-icon text-success"></i>
                <span>IVF Work Bench</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 12. ERP -->
      <div class="ms-sidebar-section" [class.is-open]="isSectionOpen('erp')">
        <div class="ms-section-header" (click)="toggleSection('erp')">
          <div class="d-flex align-items-center">
            <div class="ms-section-icon-wrapper ms-icon-secondary">
              <i class="fas fa-boxes"></i>
            </div>
            <span class="ms-section-label">ERP</span>
          </div>
          <i class="fas fa-chevron-right ms-chevron-icon" [class.rotated]="isSectionOpen('erp')"></i>
        </div>
        <div class="ms-section-body" [class.show]="isSectionOpen('erp')">
          <ul class="ms-menu-links">
            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-nav-link is-disabled"><i class="fas fa-lock ms-item-icon"></i><span>Purchases</span></a></li>
            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-nav-link is-disabled"><i class="fas fa-lock ms-item-icon"></i><span>Stores</span></a></li>
            <li *canUserAccess="['HL_ER_1']">
              <a class="ms-nav-link" [routerLink]="['/healins/ConsumptionEntry']" (click)="Event()">
                <i class="fas fa-box-open ms-item-icon text-primary"></i>
                <span>Consumption Entry</span>
              </a>
            </li>
            <li *canUserAccess="['HL_ER_18']">
              <a class="ms-nav-link" [routerLink]="['/healins/deptconsumptionentrydas']" (click)="Event()">
                <i class="fas fa-building ms-item-icon text-info"></i>
                <span>Dept Consumption Entry</span>
              </a>
            </li>
            <li *canUserAccess="['HL_ER_2']">
              <a class="ms-nav-link" [routerLink]="['/healins/MaterialTracking']" (click)="Event()">
                <i class="fas fa-truck-loading ms-item-icon text-warning"></i>
                <span>Material Tracking</span>
              </a>
            </li>
            <li *canUserAccess="['HL_ER_3']">
              <a class="ms-nav-link" [routerLink]="['/healins/servicesrevenue']" (click)="Event()">
                <i class="fas fa-chart-pie ms-item-icon text-success"></i>
                <span>Services Revenue</span>
              </a>
            </li>
            <li *canUserAccess="['HL_ER_4']">
              <a class="ms-nav-link" [routerLink]="['/healins/purchaseindent']" (click)="Event()">
                <i class="fas fa-file-signature ms-item-icon text-secondary"></i>
                <span>Purchase Indents</span>
              </a>
            </li>
            <li *canUserAccess="['HL_ER_5']">
              <a class="ms-nav-link" [routerLink]="['/healins/purchaseorder']" (click)="Event()">
                <i class="fas fa-file-invoice ms-item-icon text-primary"></i>
                <span>Purchase Orders</span>
              </a>
            </li>
            <li *canUserAccess="['HL_ER_6']">
              <a class="ms-nav-link" [routerLink]="['/healins/materialinvoice']" (click)="Event()">
                <i class="fas fa-file-alt ms-item-icon text-info"></i>
                <span>Vendor Invoices</span>
              </a>
            </li>
            <li *canUserAccess="['HL_ER_ViewPOVI']">
              <a class="ms-nav-link" [routerLink]="['/healins/povi']" (click)="Event()">
                <i class="fas fa-file-contract ms-item-icon text-indigo"></i>
                <span>Order Cum Invoice</span>
              </a>
            </li>
            <li *canUserAccess="['HL_ER_10']"><a class="ms-nav-link is-disabled"><i class="fas fa-lock ms-item-icon"></i><span>Stock Adjustments</span></a></li>
          </ul>
        </div>
      </div>

      <!-- 13. Expense -->
      <div class="ms-sidebar-section" [class.is-open]="isSectionOpen('expense')">
        <div class="ms-section-header" (click)="toggleSection('expense')">
          <div class="d-flex align-items-center">
            <div class="ms-section-icon-wrapper ms-icon-amber">
              <i class="fas fa-wallet"></i>
            </div>
            <span class="ms-section-label">Expense</span>
          </div>
          <i class="fas fa-chevron-right ms-chevron-icon" [class.rotated]="isSectionOpen('expense')"></i>
        </div>
        <div class="ms-section-body" [class.show]="isSectionOpen('expense')">
          <ul class="ms-menu-links">
            <li *canUserAccess="['HL_EXP_2']">
              <a class="ms-nav-link" [routerLink]="['/healins/Expensevo']" (click)="Event()">
                <i class="fas fa-money-check-alt ms-item-icon text-warning"></i>
                <span>Expense Voucher</span>
              </a>
            </li>
            <li *canUserAccess="['HL_EXP_1']">
              <a class="ms-nav-link" [routerLink]="['/healins/ExpenseManagement']" (click)="Event()">
                <i class="fas fa-file-alt ms-item-icon text-info"></i>
                <span>Expense Management Report</span>
              </a>
            </li>
            <li *canUserAccess="['HL_BL_HIDE']"><a class="ms-nav-link is-disabled"><i class="fas fa-lock ms-item-icon"></i><span>Other Reports</span></a></li>
          </ul>
        </div>
      </div>

      <!-- 14. Reports -->
      <div class="ms-sidebar-section" [class.is-open]="isSectionOpen('reports')">
        <div class="ms-section-header" (click)="toggleSection('reports')">
          <div class="d-flex align-items-center">
            <div class="ms-section-icon-wrapper ms-icon-green">
              <i class="far fa-file-excel"></i>
            </div>
            <span class="ms-section-label">Reports</span>
          </div>
          <i class="fas fa-chevron-right ms-chevron-icon" [class.rotated]="isSectionOpen('reports')"></i>
        </div>
        <div class="ms-section-body" [class.show]="isSectionOpen('reports')">
          <ul class="ms-menu-links">
            <li *canUserAccess="['HL_REPORT_SET_1']">
              <a class="ms-nav-link" [routerLink]="['/healins/excelreporting']" (click)="Event()">
                <i class="far fa-file-excel ms-item-icon text-success"></i>
                <span>Excel Reports</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>

  <!-- Sidebar Footer / Sign Out -->
  <div class="ms-sidebar-footer">
    <a class="ms-nav-link ms-signout-link" [routerLink]="['/signinpage']">
      <i class="fas fa-sign-out-alt ms-item-icon text-danger"></i>
      <span class="fw-semibold">Sign Out</span>
    </a>
  </div>

</div>
<!-- Microsoft Office Professional Navigation Sidebar Ends -->
